import { ActiveSubscriptions, Analytics } from '@features/user/dashboard';

export const DashBoardPage = () => {
  return (
    <div className={'flex flex-col min-w-[1000px] gap-y-6.5'}>
      <ActiveSubscriptions />
      <Analytics />
    </div>
  );
};
